let cart = window.localStorage.getItem('cart');
let customerdata = window.localStorage.getItem('customerdata');
let cartCount = window.localStorage.getItem('cartCount');
let totalOrderAmount = window.localStorage.getItem('totalOrderAmount');
let userDetails = window.localStorage.getItem('userDetails');

// PERF: Debounced localStorage saver to batch writes
let saveCartTimer = null;
const debouncedSaveCart = (state) => {
  clearTimeout(saveCartTimer);
  saveCartTimer = setTimeout(() => {
    window.localStorage.setItem('cart', JSON.stringify(state.cart));
    window.localStorage.setItem('customerdata', JSON.stringify(state.customerdata));
    window.localStorage.setItem('cartCount', state.cartCount);
    window.localStorage.setItem('totalOrderAmount', state.totalOrderAmount);
  }, 150); // Batch writes every 150ms
};

let store = {
  state: {
    cart: cart !== 'undefined' && typeof cart === 'string' ? JSON.parse(cart) : [],
    totalOrderAmount: totalOrderAmount ? parseFloat(totalOrderAmount) : 0,
    cartCount: cartCount ? parseInt(cartCount) : 0,
    customerdata: customerdata !== 'undefined' && typeof customerdata === 'string' ?
      JSON.parse(customerdata) : 'Select Customer',
    userDetails: userDetails && typeof userDetails === 'string' && userDetails !== 'undefined' ?
      JSON.parse(userDetails) : {},

    // PERF: O(1) cart lookup index - Map for instant product lookups
    cartIndex: new Map(),

    cashSession: null,
  },

  mutations: {
    // PERF: Build cart index for O(1) lookups - call after cart modifications
    // Borrowed lines are excluded on purpose: they're only ever created through
    // the Borrow Stock modal, never through barcode scanning, so the fast path
    // (addToCartFast) must never resolve a product id to a borrowed line.
    rebuildCartIndex(state) {
      state.cartIndex.clear();
      state.cart.forEach((item, idx) => {
        if (item && item.id && !item.is_borrowed) {
          state.cartIndex.set(item.id, idx);
        }
      });
    },

    setCashSession(state, session) {
      state.cashSession = session;
    },

    clearCashSession(state) {
      state.cashSession = null;
    },

    addUserDetails(state, userDetails) {
      if (userDetails && typeof userDetails === 'object') {
        state.userDetails = userDetails;
        window.localStorage.setItem('userDetails', JSON.stringify(userDetails));
      }
    },

    getUserDetails(state) {
      const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
      if (userDetails && typeof userDetails === 'object') {
        state.userDetails = userDetails;
      } else {
        state.userDetails = { roles: [] };
      }
    },

    removeUserDetails(state) {
      state.userDetails = { roles: [] };
      window.localStorage.removeItem('userDetails');
    },

    destroyUserDetails(state) {
      state.userDetails = { roles: [] };
      window.localStorage.removeItem('userDetails');
    },

    // PERF: FAST PATH mutation for barcode scanning - optimized for speed
    addToCartFast(state, item) {
      // PERF: O(1) lookup using index instead of .find()
      const existingIdx = state.cartIndex.get(item.id);

      if (existingIdx !== undefined) {
        // Item exists - increment quantity
        const found = state.cart[existingIdx];

        if (found.companySettings.has_stock_buffer) {
          found.quantity++;
          found.totalPrice = item.is_Retail ?
            parseFloat(found.quantity * found.ppu).toFixed(2) :
            parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
          if (found.conversion_factor_snapshot) {
            found.base_quantity = found.quantity * found.conversion_factor_snapshot;
          }
          state.cartCount++;
        } else {
          if (item.remaining_units > found.quantity || found.is_service) {
            found.quantity++;
            found.totalPrice = item.is_Retail ?
              parseFloat(found.quantity * found.ppu).toFixed(2) :
              parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
            if (found.conversion_factor_snapshot) {
              found.base_quantity = found.quantity * found.conversion_factor_snapshot;
            }
            state.cartCount++;
          }
        }
      } else {
        // New item - add to cart
        Vue.set(item, 'quantity', 1);
        Vue.set(item, 'totalPrice', item.is_Retail ? item.ppu : item.wholesale_sp);

        state.cart.push(item);
        state.cartIndex.set(item.id, state.cart.length - 1);
        state.cartCount++;
      }

      // PERF: Debounced save - batches multiple rapid scans
      debouncedSaveCart(state);
    },

    // Keep original addToCart for compatibility
    addToCart(state, item) {
      let found = state.cart.find(product => product.id == item.id);
      const itemsRemaining = item.remaining_units;

      if (found) {
        if (found.companySettings.has_stock_buffer) {
          found.quantity++;
          found.totalPrice = item.is_Retail ?
            parseFloat(found.quantity * found.ppu).toFixed(2) :
            parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
          state.cartCount++;
        } else {
          if (itemsRemaining > found.quantity || found.is_service) {
            found.quantity++;
            found.totalPrice = item.is_Retail ?
              parseFloat(found.quantity * found.ppu).toFixed(2) :
              parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
            state.cartCount++;
          }
        }
      } else {
        state.cart.push(item);
        Vue.set(item, 'quantity', 1);
        Vue.set(item, 'totalPrice', item.is_Retail ? item.ppu : item.wholesale_sp);
        state.cartCount++;
      }

      // PERF: Rebuild index after manual add
      this.commit('rebuildCartIndex');
      this.commit('saveCart');
    },

    removeFromCart(state, item) {
      let index = state.cart.indexOf(item);

      if (index > -1) {
        let product = state.cart[index];
        state.cartCount -= product.quantity;
        state.cart.splice(index, 1);
      }

      // PERF: Rebuild index after removal
      this.commit('rebuildCartIndex');
      this.commit('saveCart');
    },

    UpdateOrderQty(state, item) {
      // PERF: Use index for O(1) lookup
      const idx = state.cartIndex.get(item.cart_id);
      if (idx !== undefined) {
        const product = state.cart[idx];
        product.quantity = item.quantity;
        product.totalPrice = item.is_Retail ?
          parseFloat(item.quantity * product.ppu).toFixed(2) :
          parseFloat(item.quantity * product.wholesale_sp).toFixed(2);
        // A non-base unit is selected — base_quantity (what actually gets
        // deducted from stock) always tracks the entered quantity, never the
        // stale value from before the edit. See §36 Part 3.
        if (product.conversion_factor_snapshot) {
          product.base_quantity = parseFloat(item.quantity) * parseFloat(product.conversion_factor_snapshot);
        }
      }

      // Recalculate cart count
      state.cartCount = state.cart.reduce((acc, item) => acc + parseInt(item.quantity), 0);
      this.commit('saveCart');
    },

    // Attaches/changes which unit (e.g. Piece vs. Box) a cart line is sold
    // in. Recomputes base_quantity (the actual base-unit amount that will be
    // deducted from stock) and the line's price — a unit's own explicit
    // selling_price wins when set (e.g. a discounted bulk Box price),
    // otherwise the price scales by conversion_factor off the item's base
    // (per-base-unit) price. See docs/product-variations-units-architecture.md
    // §20/§36 Part 3.
    setCartUnit(state, { cart_id, unit }) {
      const idx = state.cartIndex.get(cart_id);
      if (idx === undefined) return;
      const product = state.cart[idx];
      if (!product) return;

      const factor = parseFloat(unit.conversion_factor) || 1;
      const hasUnitPrice = unit.selling_price !== null && unit.selling_price !== undefined && unit.selling_price !== '';
      const baseRetail = parseFloat(product.base_ppu) || 0;
      const baseWholesale = parseFloat(product.base_wholesale_sp != null ? product.base_wholesale_sp : product.wholesale_sp) || 0;

      Vue.set(product, 'unit_id', unit.id);
      Vue.set(product, 'unit_label', unit.unit_name);
      Vue.set(product, 'conversion_factor_snapshot', factor);
      Vue.set(product, 'base_quantity', (parseFloat(product.quantity) || 0) * factor);

      product.ppu = hasUnitPrice ? parseFloat(unit.selling_price) : parseFloat((baseRetail * factor).toFixed(2));
      product.wholesale_sp = hasUnitPrice ? parseFloat(unit.selling_price) : parseFloat((baseWholesale * factor).toFixed(2));
      product.totalPrice = product.is_Retail ?
        parseFloat(product.quantity * product.ppu).toFixed(2) :
        parseFloat(product.quantity * product.wholesale_sp).toFixed(2);

      this.commit('saveCart');
    },

    UpdateTotalAmount(state, amount) {
      state.totalOrderAmount = amount;
      // PERF: Debounced save for frequent updates
      debouncedSaveCart(state);
    },

    updatePricesOnTheGo(state, item) {
        const idx = state.cartIndex.get(item.cart_id);
        if (idx === undefined) return;

        const product = state.cart[idx];
        if (!product) return;

        let newPrice = parseFloat(item.newPriceChange);

        // Apply price floor if not a service
        if (!product.is_service & !product.is_directly_proportional) {
            const companySettings = state.userDetails.company.companysettings;

            // Determine the minimum allowed price
            let minPrice = 0;
            if (companySettings.price_not_go_below_wholesale) {
            // Price cannot go below wholesale selling price
            minPrice = product.wholesale_sp || 0;
            } else {
            // Price cannot go below buying price
            minPrice = product.wholesale_ppu || 0;
            }

            if (newPrice < minPrice) {
            newPrice = minPrice;
            }
        }

        // Update price & totals
        if (product.is_directly_proportional) {
            product.totalPrice = parseFloat(newPrice).toFixed(2);
            product.quantity = parseFloat(newPrice / product.ppu).toFixed(2);
            product.ppu = parseFloat(newPrice).toFixed(2);
        } else if (product.is_service || state.userDetails.company.companysettings.allows_price_change_on_the_go) {
            product.ppu = parseFloat(newPrice).toFixed(2);
            product.totalPrice = parseFloat(product.ppu * product.quantity).toFixed(2);
        }

    this.commit('saveCart');
    },

    // Rounds a fractional-qty line's TOTAL (e.g. 37.50 for 0.25kg @ 150/kg
    // -> 40), deliberately separate from updatePricesOnTheGo above. That
    // mutation's newPrice means "per-unit price" for any quantity - reusing
    // it here (or making it total-aware) would make a cashier correcting a
    // normal multi-qty line's per-unit rate get silently reinterpreted as a
    // line-total edit instead (this exact bug shipped and was reverted
    // before - see cld/prorated-bp-floor-and-total-modal history). So this
    // is a new mutation, only ever reachable from the fractional-qty
    // "round total" trigger in Salespage.vue, and it only ever sets
    // totalPrice - ppu (the catalog rate) is never touched, so a later
    // plain quantity change (UpdateOrderQty) still multiplies against the
    // real rate, not a corrupted one.
    overrideLineTotal(state, item) {
        const idx = state.cartIndex.get(item.cart_id);
        if (idx === undefined) return;

        const product = state.cart[idx];
        if (!product || product.is_service || product.is_directly_proportional) return;

        let newTotal = parseFloat(item.newTotal);
        if (isNaN(newTotal) || newTotal < 0) return;

        // Same buying-price floor as updatePricesOnTheGo, pro-rated to this
        // line's quantity since newTotal is a TOTAL, not a per-unit rate -
        // a flat per-unit floor would wrongly reject a valid fractional-qty
        // total (e.g. 30 for 0.25kg against a 100/kg buying price, real
        // floor = 25).
        const companySettings = state.userDetails.company.companysettings;
        const minPricePerUnit = companySettings.price_not_go_below_wholesale
            ? (product.wholesale_sp || 0)
            : (product.wholesale_ppu || 0);
        const proRatedFloor = minPricePerUnit * (parseFloat(product.quantity) || 0);
        if (newTotal < proRatedFloor) {
            newTotal = proRatedFloor;
        }

        product.totalPrice = parseFloat(newTotal).toFixed(2);

        this.commit('saveCart');
    },


    addOrderingCustomer(state, customer) {
      state.customerdata = customer;
      this.commit('saveCart');
    },

    // PERF: Immediate save for critical operations (checkout, manual saves)
    saveCart(state) {
      // Cancel any pending debounced save
      clearTimeout(saveCartTimer);

      // Immediate save
      window.localStorage.setItem('cart', JSON.stringify(state.cart));
      window.localStorage.setItem('customerdata', JSON.stringify(state.customerdata));
      window.localStorage.setItem('cartCount', state.cartCount);
      window.localStorage.setItem('totalOrderAmount', state.totalOrderAmount);
    },

    resetState(state) {
      const s = state;
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },

    resetStore(state) {
      // Reset state data
      state.cart = [];
      state.cartCount = 0;
      state.customerdata = 'Select Customer';
      state.totalOrderAmount = 0;
      state.cartIndex.clear();

      // Clear localStorage
      const keysToClear = ['cart', 'cartCount', 'customerdata', 'totalOrderAmount'];
      keysToClear.forEach(key => localStorage.removeItem(key));
    },

    // Added via the Borrow Stock modal - always pushed as a new, distinct line,
    // never merged into an existing cart line for the same product (borrowed
    // or not), so borrowed_stock_id is never lost to a qty-merge.
    addBorrowedToCart(state, item) {
      Vue.set(item, 'is_borrowed', true);
      Vue.set(item, 'totalPrice', item.is_Retail ?
        parseFloat(item.quantity * item.ppu).toFixed(2) :
        parseFloat(item.quantity * item.wholesale_sp).toFixed(2));

      state.cart.push(item);
      state.cartCount += parseInt(item.quantity);

      // rebuildCartIndex already skips is_borrowed lines - see above.
      this.commit('rebuildCartIndex');
      this.commit('saveCart');
    },
  },

  actions: {
    getUserDetails({ commit }) {
      let userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
      if (!userDetails || typeof userDetails !== 'object') {
        userDetails = { roles: [] };
      }
      commit('addUserDetails', userDetails);
    },

    resetState({ commit }) {
      commit('resetState');
    },

    resetStore({ commit }) {
      commit('resetStore');
    },
  },

  getters: {
    userDetails(state) {
      return state.userDetails;
    },
  },
};

// PERF: Build initial cart index on store creation
if (store.state.cart && Array.isArray(store.state.cart)) {
  store.state.cart.forEach((item, idx) => {
    if (item && item.id && !item.is_borrowed) {
      store.state.cartIndex.set(item.id, idx);
    }
  });
}

export default store;
